export default __webpack_public_path__ + "static/media/25081101.9c9dad27.jpg";